import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { ProductAuxEffects } from './product-aux.effects';

@NgModule({
  declarations: [],
  imports: [CommonModule, EffectsModule.forFeature([ProductAuxEffects])],
})
export class ProductAuxStoreModule {}
